<template>
  <div class="">
    <router-view />
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  body{
    background-color:#373330;
  }
</style>
<script>
export default {
    name: 'App'
}
</script>
